module.exports = __webpack_public_path__ + "static/jfm-b5cc478e9467e53fd061481212707bef.png";